import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { clubQueryKeys } from "./clubQueryKeys";

export const useQueryClubGetCommunicationProperties = ({
  api,
  clubId,
}: {
  api: ApiType;
  clubId: number;
}) =>
  useQuery({
    queryKey: clubQueryKeys.getCommunicationProperties(clubId),
    queryFn: async () => {
      return (await api.clubApi.getCommunicationProperties(clubId)).data;
    },
  });
